import { IBreadcrumb } from '~/lib/data-contract';
import { BreadcrumbLink } from '~/shared/components/BreadcrumbLink/BreadcrumbLink';

export type N55BreadcrumbProps = {
	breadcrumb: IBreadcrumb;
	className?: string;
};

export const N55Breadcrumb = ({ breadcrumb, className }: N55BreadcrumbProps) => {
	const lastBreadcrumb = breadcrumb.items?.[breadcrumb.items?.length - 2];

	if (!lastBreadcrumb || !lastBreadcrumb.url) {
		// TODO: url should be required
		return null;
	}

	return (
		<BreadcrumbLink
			url={lastBreadcrumb.url}
			className={className}
			text={lastBreadcrumb.text}
		/>
	);
};
